<template>
  <div>
    <div class="row">
      <div class="k-card-wrapper col-12 col-md-12 col-lg-12 col-xl-8" v-if="$mq !== 'xs' && $mq !== 'sm'">
        <subscribe
            class="h-100"
            :title="menu.title"
            :bought="isLoading ? true : checkSubscribeIsBought"
            :menuId="displayMenuId"
            special
            :price="menu.price"
            @prevSubscribe="setPrevSubscribe()"
            @nextSubscribe="setNextSubscribe()"
            :isLoading="isLoading"
            :isShowArrows="getAvaiableUserSets.length > 1"
        />
      </div>
      <div class="k-card-wrapper col-12 col-md-12 col-lg-12 col-xl-8 p-0" v-else-if="getAvaiableUserSets.length > 0">
        <swiper
            class="swiper"
            :options="swiperOption"
            @slideChange="onSlideChange"
            @ready="onSlideInit"
            @slideChangeTransitionStart="disableSwiper = true"
            @slideChangeTransitionEnd="disableSwiper = false"
            ref="mySwiper"
            :style="{ 'pointer-events': disableSwiper ? 'none' : 'all' }"
        >
          <swiper-slide v-for="set in getAvaiableUserSets" :key="set.id">
            <subscribe
                class="k-card-swiper-overhead"
                :title="set.title"
                :bought="checkCurrentSubscribeIsBought(set)"
                :menuId="set.id"
                special
                single
                :price="set.price"
                @show-more="showRecipePopup"
                :isShowArrows="getAvaiableUserSets.length > 1"
            />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>

        <!--
        <slick
          ref="slick"
          :options="slickOptions"
          @swipe="handleSwipe"
          @init="onInit"
          v-if="getAvaiableUserSets.length > 0"
          :style="{ 'pointer-events': isLoading ? 'none' : 'all' }"
        >
          <subscribe
            v-for="set in getAvaiableUserSets"
            :key="set.id"
            :title="set.title"
            :bought="checkCurrentSubscribeIsBought(set)"
            :menuId="set.id"
            special
            single
            :price="set.price"
            @show-more="showRecipePopup"
          />
        </slick>
        -->

        <template v-for="set in getAvaiableUserSets">
          <recipe-popup
              v-if="activeRecipePopup === set.id"
              :key="set.id"
              :title="set.title"
              :bought="checkCurrentSubscribeIsBought(set)"
              :menuId="set.id"
              special
              single
              :price="set.price"
              @get-back="backToMenu"
          />
        </template>
      </div>
      <div class="k-card-wrapper col-12 col-md-12 col-lg-12 col-xl-4">
        <div class="k-family k-card h-100">
          <div class="k-family-header">
            <div class="k-family__title">Семья</div>
            <div class="k-family__add-icon cursor-pointer" @click="$router.push({ name: 'UserSubscribes' })">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.6448 6.60794L13.8095 6.15659C13.6992 5.80869 13.5573 5.47131 13.3861 5.14859C13.6616 4.68991 14.2407 3.7245 14.2407 3.7245C14.3515 3.54003 14.3222 3.30381 14.1702 3.15184L12.8445 1.82616C12.6926 1.67372 12.4568 1.64444 12.2719 1.75566L10.8455 2.61031C10.5246 2.44047 10.189 2.29994 9.84344 2.19053L9.39209 0.35525C9.33988 0.1465 9.15266 0 8.9375 0H7.0625C6.84734 0 6.65966 0.1465 6.60794 0.355219C6.60794 0.355219 6.29528 1.63616 6.15703 2.19006C5.78853 2.30678 5.43241 2.45831 5.09319 2.64325L3.61416 1.75566C3.42922 1.64578 3.19394 1.67419 3.0415 1.82616L1.71581 3.15184C1.56384 3.30381 1.53453 3.54003 1.64531 3.7245L2.55994 5.25206C2.41253 5.54275 2.28894 5.84531 2.19053 6.15522L0.35525 6.60794C0.1465 6.66012 0 6.84734 0 7.0625V8.9375C0 9.15266 0.1465 9.34034 0.355219 9.39206L2.19097 9.84341C2.30222 10.1963 2.44684 10.5392 2.62219 10.8683L1.80372 12.2325C1.69294 12.4169 1.72225 12.6532 1.87422 12.8051L3.19991 14.1308C3.35144 14.2823 3.58763 14.3112 3.77256 14.2013C3.77256 14.2013 4.69038 13.6511 5.13991 13.3819C5.46537 13.5554 5.80594 13.6987 6.15706 13.8099L6.60797 15.6447C6.65966 15.8535 6.84734 16 7.0625 16H8.9375C9.15266 16 9.33987 15.8535 9.39206 15.6448L9.84297 13.8099C10.2042 13.6955 10.552 13.5476 10.883 13.3682C11.3449 13.6451 12.2718 14.2013 12.2718 14.2013C12.4563 14.3116 12.6925 14.2832 12.8445 14.1308L14.1702 12.8051C14.3222 12.6532 14.3515 12.4169 14.2407 12.2325L13.3979 10.8285C13.5641 10.5131 13.7019 10.1831 13.8095 9.84341L15.6447 9.39206C15.8535 9.33987 16 9.15266 16 8.9375V7.0625C16 6.84734 15.8535 6.66012 15.6448 6.60794ZM8 11.2812C6.19091 11.2812 4.71875 9.80909 4.71875 8C4.71875 6.19091 6.19091 4.71875 8 4.71875C9.80909 4.71875 11.2812 6.19091 11.2812 8C11.2812 9.80909 9.80909 11.2812 8 11.2812Z"
                    fill="#646465"/>
              </svg>
            </div>
          </div>
          <div class="k-family__members" v-if="isBoughtedAndFamily">
            <perfect-scrollbar>
              <div class="k-family__member" v-for="member in getUserFamilySubscribe" :key="member.id">
                <img
                    v-if="member.avatar_url"
                    class="k-family__member-avatar"
                    :src="member.avatar_url"
                    alt="avatar"
                />
                <div
                    v-else
                    class="k-family__member-avatar k-family__member-no-avatar"
                >{{ member.name[0] }}
                </div>
                <div class="k-family__member-name">{{ member.name }}</div>
                <div class="k-family__badges">
                  <div class="k-article__badges" v-if="false">
                    <span class="k-badge badge k-badge-green-light">Завтрак</span>
                    <span class="k-badge badge k-badge-orange-light">Обед</span>
                    <span class="k-badge badge k-badge-green-light">Перекус</span>
                    <span class="k-badge badge k-badge-red-light">Ужин</span>
                  </div>
                </div>
              </div>
            </perfect-scrollbar>
          </div>
          <div v-else class="k-subscribes__no-buy-family-wrapper">
            <p
                class="k-subscribes__no-buy-family-title"
            >Здесь будут отображаться все члены семьи, которые питаются по этому меню</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="k-card-wrapper col-12">
        <div class="k-card k-menu">
          <div v-if="currentSetsObject.error" role="alert" class="recovery-notice">
            {{ currentSetsObject.error }}
            <button type="button" @click="loadSpecial($route.params.id)">Повторить загрузку</button>
          </div>
          <k-spinner class="mx-auto" v-else-if="isLoading"/>
          <div v-else-if="!sets.length" class="text-center my-4" role="status">В этом сборнике пока нет опубликованных рецептов.</div>
          <div v-else>
            <div class="k-menu__header">
              <div class="main-menu__wrapper">
                <div class="nav justify-content-center main-menu">
                  <div
                      class="nav-item main-menu__item-wrapper"
                      :class="{ active: set.title === currentSet }"
                      v-for="(set, index) in getSets"
                      :key="index"
                  >
                    <a
                        class="main-menu__item nav-link"
                        href="#"
                        @click.prevent="selectCategory(set.title)"
                    >{{ set.title }}</a>
                  </div>
                  <div
                      class="nav-item main-menu__item-wrapper"
                      :class="{ active: !currentSet }"
                      key="set-all"
                  >
                    <a
                        class="main-menu__item nav-link"
                        href="#"
                        @click.prevent="selectCategory(null)"
                    >Все</a>
                  </div>
                </div>
              </div>
              <div style="text-align: center;">
                <BaseInput
                    v-model="searchRecipe"
                    title="Название рецепта"
                    placeholder="Поиск рецептов по названию"
                    class="search-input"
                    clearable
                />
              </div>
            </div>
            <div class="k-menu__body">
              <div class="d-flex flex-wrap mt-4" style="justify-content: center; max-width: 1300px; margin: 0 auto;">
                <div v-if="!getCurrentSetRecipes.length" class="text-center my-4" style="color: #A0A0A0;">
                  Ничего не удалось найти
                </div>
                <div
                    class="k-menu__dish-card mb-2"
                    v-for="(recipe, index) in getCurrentSetRecipes"
                    :key="index"
                    role="button" tabindex="0"
                    :aria-label="recipe.title + (checkSubscribeIsBought ? '. Открыть рецепт' : '. Рецепт закрыт, нужен доступ')"
                    @keydown.enter.self.prevent="openRecipe(recipe)"
                    @keydown.space.self.prevent="openRecipe(recipe)"
                    @click="!checkSubscribeIsBought && showNotify()"
                >
                  <div
                      :class="{'k-menu__dish': true, disabled: !checkSubscribeIsBought }"
                      @click.self.stop="openRecipe(recipe)"
                  >
                    <div
                        @click.stop="openRecipe(recipe)"
                        class="k-menu__dish-photo col-sm-3 col-lg-4 p-0 d-flex align-items-center mr-2"
                        style="flex-direction: column;"
                    >
                      <img class="k-menu__dish-img" :src="recipe.cover_url" loading="lazy" decoding="async" :alt="recipe.title"/>
                      <div style="width: 40px; height: 20px;">
                        <VeganIcon v-if="recipeHasTag(recipe.id, 'Веган')" class="recipe-left-tag-icon"/>
                        <VeganIcon v-else-if="recipeHasTag(recipe.id, 'Веган молочка')" color="#FFCC1B" class="recipe-left-tag-icon"/>
                        <EggIcon v-else-if="recipeHasTag(recipe.id, 'С яйцами')" class="recipe-left-tag-icon"/>
                      </div>
                    </div>
                    <div class="k-menu__dish-body"
                         @click.stop="openRecipe(recipe)">
                      <div
                          class="k-menu__dish-description mb-2"
                      >
                        <span class="d-flex flex-column">
                          <span class="k-menu__warning-text" v-if="recipe.preparing_desc">
                            <svg class="mr-1" width="9" height="8" viewBox="0 0 9 8" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <path
                                  d="M8.86037 6.23744C8.85784 6.23261 8.8552 6.22787 8.85243 6.22318L5.50428 0.578479C5.04727 -0.193571 3.95166 -0.192081 3.49587 0.578479L0.147729 6.22318C0.144951 6.22785 0.142314 6.23261 0.139783 6.23742C-0.277645 7.03679 0.29027 8 1.17521 8H7.82495C8.71192 8 9.27681 7.03496 8.86037 6.23744ZM7.82495 7.40072H1.17521C0.734487 7.40072 0.452287 6.92385 0.65412 6.52597L3.99789 0.888686C4.22635 0.502427 4.77426 0.503199 5.00227 0.888686C5.00232 0.888793 5.00239 0.888883 5.00246 0.889009L8.34603 6.52599C8.54801 6.92413 8.26542 7.40072 7.82495 7.40072Z"
                                  fill="#D51E3A"/>
                              <path
                                  d="M4.50029 2.01074C4.33827 2.01074 4.20691 2.14489 4.20691 2.31039V5.3068C4.20691 5.47229 4.33825 5.60645 4.50029 5.60645C4.66231 5.60645 4.79367 5.47229 4.79367 5.3068V2.31039C4.79367 2.14491 4.66231 2.01074 4.50029 2.01074Z"
                                  fill="#D51E3A"/>
                              <path
                                  d="M4.50029 6.20508C4.33843 6.20508 4.20691 6.33968 4.20691 6.50473C4.20691 6.66978 4.33841 6.80438 4.50029 6.80438C4.66215 6.80438 4.79367 6.66978 4.79367 6.50473C4.79367 6.33968 4.66215 6.20508 4.50029 6.20508Z"
                                  fill="#D51E3A"/>
                            </svg>
                            Требуется подготовка
                          </span>
                          {{ recipe.title }}
                        </span>
                      </div>
                      <div v-if="recipe.info" class="k-menu__dish-calories align-self-start"
                           @click.stop="openRecipe(recipe)">
                        <div class="badge k-badge k-badge-orange-light">
                          Ккал
                          {{ recipe.info.calories }}
                        </div>
                        <div class="badge k-badge-multi">
                          <!-- TODO: fix this on the back end -->
                          <div class="k-badge-red-light">Б
                            {{ Math.round(recipe.info.proteinsWeight * 100 / recipe.mass_change) }}
                          </div>
                          <div class="k-badge-orange-light">Ж
                            {{ Math.round(recipe.info.fatsWeight * 100 / recipe.mass_change) }}
                          </div>
                          <div class="k-badge-green-light">У
                            {{ Math.round(recipe.info.carbohydratesWeight * 100 / recipe.mass_change) }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="k-menu__dish-actions" :class="{ 'justify-content-start': !checkSubscribeIsBought }">
                      <svg v-show="!checkSubscribeIsBought" class="k-menu__lock ml-2" width="17" height="24"
                           viewBox="0 0 17 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.1312 9.49941V5.80519C14.1312 2.63873 11.5812 0 8.4999 0C5.41865 0 2.86865 2.63873 2.86865 5.80519V9.49941H5.7374V5.80519C5.63115 4.22196 6.90615 2.84982 8.4999 2.84982C10.0937 2.84982 11.3687 4.11641 11.3687 5.80519V9.49941H14.1312Z"
                            fill="#C1C1C1"/>
                        <path
                            d="M0 13.0883V20.3711C0 21.9544 1.275 23.221 2.86875 23.221H14.2375C15.8312 23.221 17.1063 21.9544 17.1063 20.2656V12.9827C17.1063 11.3995 15.8312 10.0273 14.2375 10.0273H2.86875C1.275 10.1329 0 11.505 0 13.0883ZM8.5 14.4604C9.24375 14.4604 9.88125 15.0937 9.88125 15.9381C9.88125 16.4658 9.5625 16.888 9.1375 17.2047V19.6323C9.1375 20.0545 8.81875 20.3711 8.39375 20.3711C7.96875 20.3711 7.65 20.0545 7.65 19.6323V17.2047C7.225 16.9936 6.90625 16.4658 6.90625 15.9381C7.11875 15.1992 7.75625 14.4604 8.5 14.4604Z"
                            fill="#C1C1C1"/>
                      </svg>
                      <!-- <div v-show="recipe.date && checkSubscribeIsBought" class="k-menu__dish-actions-add mb-auto"> -->
                      <div v-show="false" class="k-menu__dish-actions-add mb-auto">
                        <adaptive-propper noscrollbar height="auto">
                          <template #element>
                            <div class="k-menu__plus-button">
                              <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect x="7.11111" width="1.77778" height="16" rx="0.888889" fill="#fff"/>
                                <rect
                                    x="16"
                                    y="7.11108"
                                    width="1.77778"
                                    height="16"
                                    rx="0.888889"
                                    transform="rotate(90 16 7.11108)"
                                    fill="#fff"
                                />
                              </svg>
                            </div>
                          </template>
                          <template #content>
                            <div>
                              <switcher class="k-sprecial-filter" :items="getDishTypeSwitch"
                                        :activeItem.sync="recipe.meal_type" color="orange"
                                        @update:activeItem="makeDateRecipe(recipe)"/>
                              <!-- <div class="k-family__members" v-if="isBoughtedAndFamily">
                                <perfect-scrollbar>
                                  <div class="k-family__members-submit" v-for="member in getUserFamilySubscribe" :key="member.id">
                                    <div class="k-family__members-submit__container">
                                      <img
                                        v-if="member.avatar_url"
                                        class="k-family__member-avatar-submit"
                                        :src="member.avatar_url"
                                        alt="avatar"
                                      />
                                      <div
                                        v-else
                                        class="k-family__member-no-avatar-submit"
                                      >{{ member.name[0] }}</div>
                                      <div class="k-family__member-name">{{ member.name }}</div>
                                    </div>
                                    <div>

                                    </div>
                                  </div>
                                </perfect-scrollbar>
                              </div> -->
                              <div class="k-recipe__persons">
                                <div class="k-family__members-submit" v-for="person in getUserFamilySubscribe"
                                     :key="person.id">
                                  <div class="k-family__members-submit__container">
                                    <img v-if="person.avatar_url" class="k-family__member-avatar-submit"
                                         :src="person.avatar_url" alt="avatar">
                                    <div v-else class="k-family__member-no-avatar-submit">{{ person.name[0] }}</div>

                                    <div class="k-recipe__persons-name">
                                      {{ person.name }}
                                    </div>
                                  </div>
                                  <div class="k-recipe__check-badge k-badge-orange-light"
                                       v-if="person.cooking_for === 'f'" @click="cookingFor(person, true)"
                                       style="height: 30px;">
                                    <span>
                                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                           xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z"
                                              fill="#F68C1E"/>
                                      </svg>
                                    </span>
                                    <span>
                                      Добавить
                                    </span>
                                  </div>
                                  <div class="k-recipe__check-badge k-badge-green-light" v-else
                                       @click="cookingFor(person, false)" style="height: 30px;">
                                    <span>
                                      <svg width="14" height="13" viewBox="0 0 14 13" fill="none"
                                           xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 7.93846L5.11429 12L13 1" stroke="#9DC43B" stroke-width="1.5"
                                              stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                    </span>
                                    <span>
                                      Будет есть
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </adaptive-propper>
                      </div>
                      <k-calendar
                          autobox
                          title="Выберите дату рецепта в списке покупок"
                          v-if="checkSubscribeIsBought && isSomebodyInMenu"
                          :specialData="recipe"
                          :menuId="displayMenuId"
                          @date="date => setDateToRecipe(recipe, date)"
                          :currentSetDate="recipe.date"
                          description="Блюдо будет добавлено в список покупок на выбранную вами дату"
                      >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style="cursor: pointer;"
                        >
                          <path
                              d="M4.8125 19.5625C4.8125 20.6996 5.73787 21.625 6.875 21.625C8.01213 21.625 8.9375 20.6996 8.9375 19.5625C8.9375 18.4254 8.01213 17.5 6.875 17.5C5.73787 17.5 4.8125 18.4254 4.8125 19.5625ZM7.5625 19.5625C7.5625 19.9413 7.25381 20.25 6.875 20.25C6.49619 20.25 6.1875 19.9413 6.1875 19.5625C6.1875 19.1837 6.49619 18.875 6.875 18.875C7.25381 18.875 7.5625 19.1837 7.5625 19.5625Z"
                              :fill="getFillColorByMeal(recipe)"
                          />
                          <path
                              d="M17.1875 19.5625C17.1875 18.4254 16.2621 17.5 15.125 17.5C13.9879 17.5 13.0625 18.4254 13.0625 19.5625C13.0625 20.6996 13.9879 21.625 15.125 21.625C16.2621 21.625 17.1875 20.6996 17.1875 19.5625ZM14.4375 19.5625C14.4375 19.1837 14.7462 18.875 15.125 18.875C15.5038 18.875 15.8125 19.1837 15.8125 19.5625C15.8125 19.9413 15.5038 20.25 15.125 20.25C14.7462 20.25 14.4375 19.9413 14.4375 19.5625Z"
                              :fill="getFillColorByMeal(recipe)"
                          />
                          <path
                              d="M2.81875 3.0625C2.904 3.87444 3.85275 12.8862 3.99919 14.2784C4.10987 15.3309 4.99194 16.125 6.05069 16.125H16.764C17.7299 16.125 18.5783 15.4389 18.7811 14.4943L20.4325 6.78806C20.5198 6.37969 20.4194 5.95963 20.1568 5.63581C19.8942 5.31131 19.5044 5.125 19.0871 5.125H4.41856L4.12156 2.3035C4.08444 1.95288 3.7895 1.6875 3.4375 1.6875H1.375C0.9955 1.6875 0.6875 1.9955 0.6875 2.375C0.6875 2.7545 0.9955 3.0625 1.375 3.0625H2.81875ZM19.0871 6.5L17.4364 14.2062C17.3683 14.5211 17.0857 14.75 16.7633 14.75H6.05069C5.69731 14.75 5.40375 14.4853 5.36663 14.1347L4.56294 6.5H19.0871Z"
                              :fill="getFillColorByMeal(recipe)"
                          />
                        </svg>
                        <!--                        <svg-->
                        <!--                          v-if="!checkDateExist(recipe)"-->
                        <!--                          width="16"-->
                        <!--                          height="18"-->
                        <!--                          viewBox="0 0 16 18"-->
                        <!--                          fill="none"-->
                        <!--                          xmlns="http://www.w3.org/2000/svg"-->
                        <!--                        >-->
                        <!--                          <path-->
                        <!--                            d="M4.44444 0V1.8H11.5556V0H13.3333V1.8H14.2222C15.2 1.8 16 2.61 16 3.6V16.2C16 17.19 15.2 18 14.2222 18H1.77778C0.791111 18 0 17.19 0 16.2L0.00888888 3.6C0.00888888 2.61 0.791111 1.8 1.77778 1.8H2.66667V0H4.44444ZM14.2222 6.3H1.77778V16.2H14.2222V6.3Z"-->
                        <!--                            fill="#F7981E"-->
                        <!--                          />-->
                        <!--                          <path-->
                        <!--                            fill-rule="evenodd"-->
                        <!--                            clip-rule="evenodd"-->
                        <!--                            d="M8.88954 8.55078V10.3508H10.6673V12.1508H8.88865L8.88954 13.9508H7.11176L7.11087 12.1508H5.33398V10.3508H7.11176V8.55078H8.88954Z"-->
                        <!--                            fill="#F7981E"-->
                        <!--                          />-->
                        <!--                        </svg>-->
                        <!--                        <svg-->
                        <!--                          v-else-->
                        <!--                          width="22"-->
                        <!--                          height="22"-->
                        <!--                          viewBox="0 0 22 22"-->
                        <!--                          xmlns="http://www.w3.org/2000/svg"-->
                        <!--                        >-->
                        <!--                          <path-->
                        <!--                            d="M4.8125 19.5625C4.8125 20.6996 5.73787 21.625 6.875 21.625C8.01213 21.625 8.9375 20.6996 8.9375 19.5625C8.9375 18.4254 8.01213 17.5 6.875 17.5C5.73787 17.5 4.8125 18.4254 4.8125 19.5625ZM7.5625 19.5625C7.5625 19.9413 7.25381 20.25 6.875 20.25C6.49619 20.25 6.1875 19.9413 6.1875 19.5625C6.1875 19.1837 6.49619 18.875 6.875 18.875C7.25381 18.875 7.5625 19.1837 7.5625 19.5625Z"-->
                        <!--                            fill="#A3A3A3"-->
                        <!--                          />-->
                        <!--                          <path-->
                        <!--                            d="M17.1875 19.5625C17.1875 18.4254 16.2621 17.5 15.125 17.5C13.9879 17.5 13.0625 18.4254 13.0625 19.5625C13.0625 20.6996 13.9879 21.625 15.125 21.625C16.2621 21.625 17.1875 20.6996 17.1875 19.5625ZM14.4375 19.5625C14.4375 19.1837 14.7462 18.875 15.125 18.875C15.5038 18.875 15.8125 19.1837 15.8125 19.5625C15.8125 19.9413 15.5038 20.25 15.125 20.25C14.7462 20.25 14.4375 19.9413 14.4375 19.5625Z"-->
                        <!--                            fill="#A3A3A3"-->
                        <!--                          />-->
                        <!--                          <path-->
                        <!--                            d="M2.81875 3.0625C2.904 3.87444 3.85275 12.8862 3.99919 14.2784C4.10987 15.3309 4.99194 16.125 6.05069 16.125H16.764C17.7299 16.125 18.5783 15.4389 18.7811 14.4943L20.4325 6.78806C20.5198 6.37969 20.4194 5.95963 20.1568 5.63581C19.8942 5.31131 19.5044 5.125 19.0871 5.125H4.41856L4.12156 2.3035C4.08444 1.95288 3.7895 1.6875 3.4375 1.6875H1.375C0.9955 1.6875 0.6875 1.9955 0.6875 2.375C0.6875 2.7545 0.9955 3.0625 1.375 3.0625H2.81875ZM19.0871 6.5L17.4364 14.2062C17.3683 14.5211 17.0857 14.75 16.7633 14.75H6.05069C5.69731 14.75 5.40375 14.4853 5.36663 14.1347L4.56294 6.5H19.0871Z"-->
                        <!--                            fill="#A3A3A3"-->
                        <!--                          />-->
                        <!--                        </svg>-->
                      </k-calendar>
                      <div v-else-if="checkSubscribeIsBought && !isSomebodyInMenu" @click="showEmptySet">
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style="cursor: pointer;"
                        >
                          <path
                              d="M4.8125 19.5625C4.8125 20.6996 5.73787 21.625 6.875 21.625C8.01213 21.625 8.9375 20.6996 8.9375 19.5625C8.9375 18.4254 8.01213 17.5 6.875 17.5C5.73787 17.5 4.8125 18.4254 4.8125 19.5625ZM7.5625 19.5625C7.5625 19.9413 7.25381 20.25 6.875 20.25C6.49619 20.25 6.1875 19.9413 6.1875 19.5625C6.1875 19.1837 6.49619 18.875 6.875 18.875C7.25381 18.875 7.5625 19.1837 7.5625 19.5625Z"
                              :fill="getFillColorByMeal(recipe)"
                          />
                          <path
                              d="M17.1875 19.5625C17.1875 18.4254 16.2621 17.5 15.125 17.5C13.9879 17.5 13.0625 18.4254 13.0625 19.5625C13.0625 20.6996 13.9879 21.625 15.125 21.625C16.2621 21.625 17.1875 20.6996 17.1875 19.5625ZM14.4375 19.5625C14.4375 19.1837 14.7462 18.875 15.125 18.875C15.5038 18.875 15.8125 19.1837 15.8125 19.5625C15.8125 19.9413 15.5038 20.25 15.125 20.25C14.7462 20.25 14.4375 19.9413 14.4375 19.5625Z"
                              :fill="getFillColorByMeal(recipe)"
                          />
                          <path
                              d="M2.81875 3.0625C2.904 3.87444 3.85275 12.8862 3.99919 14.2784C4.10987 15.3309 4.99194 16.125 6.05069 16.125H16.764C17.7299 16.125 18.5783 15.4389 18.7811 14.4943L20.4325 6.78806C20.5198 6.37969 20.4194 5.95963 20.1568 5.63581C19.8942 5.31131 19.5044 5.125 19.0871 5.125H4.41856L4.12156 2.3035C4.08444 1.95288 3.7895 1.6875 3.4375 1.6875H1.375C0.9955 1.6875 0.6875 1.9955 0.6875 2.375C0.6875 2.7545 0.9955 3.0625 1.375 3.0625H2.81875ZM19.0871 6.5L17.4364 14.2062C17.3683 14.5211 17.0857 14.75 16.7633 14.75H6.05069C5.69731 14.75 5.40375 14.4853 5.36663 14.1347L4.56294 6.5H19.0871Z"
                              :fill="getFillColorByMeal(recipe)"
                          />
                        </svg>
                        <!--                        <svg-->
                        <!--                          v-if="!checkDateExist(recipe)"-->
                        <!--                          width="16"-->
                        <!--                          height="18"-->
                        <!--                          viewBox="0 0 16 18"-->
                        <!--                          fill="none"-->
                        <!--                          xmlns="http://www.w3.org/2000/svg"-->
                        <!--                        >-->
                        <!--                          <path-->
                        <!--                            d="M4.44444 0V1.8H11.5556V0H13.3333V1.8H14.2222C15.2 1.8 16 2.61 16 3.6V16.2C16 17.19 15.2 18 14.2222 18H1.77778C0.791111 18 0 17.19 0 16.2L0.00888888 3.6C0.00888888 2.61 0.791111 1.8 1.77778 1.8H2.66667V0H4.44444ZM14.2222 6.3H1.77778V16.2H14.2222V6.3Z"-->
                        <!--                            fill="#F7981E"-->
                        <!--                          />-->
                        <!--                          <path-->
                        <!--                            fill-rule="evenodd"-->
                        <!--                            clip-rule="evenodd"-->
                        <!--                            d="M8.88954 8.55078V10.3508H10.6673V12.1508H8.88865L8.88954 13.9508H7.11176L7.11087 12.1508H5.33398V10.3508H7.11176V8.55078H8.88954Z"-->
                        <!--                            fill="#F7981E"-->
                        <!--                          />-->
                        <!--                        </svg>-->
                        <!--                        <svg-->
                        <!--                          v-else-->
                        <!--                          width="22"-->
                        <!--                          height="22"-->
                        <!--                          viewBox="0 0 22 22"-->
                        <!--                          xmlns="http://www.w3.org/2000/svg"-->
                        <!--                        >-->
                        <!--                          <path-->
                        <!--                            d="M4.8125 19.5625C4.8125 20.6996 5.73787 21.625 6.875 21.625C8.01213 21.625 8.9375 20.6996 8.9375 19.5625C8.9375 18.4254 8.01213 17.5 6.875 17.5C5.73787 17.5 4.8125 18.4254 4.8125 19.5625ZM7.5625 19.5625C7.5625 19.9413 7.25381 20.25 6.875 20.25C6.49619 20.25 6.1875 19.9413 6.1875 19.5625C6.1875 19.1837 6.49619 18.875 6.875 18.875C7.25381 18.875 7.5625 19.1837 7.5625 19.5625Z"-->
                        <!--                            fill="#A3A3A3"-->
                        <!--                          />-->
                        <!--                          <path-->
                        <!--                            d="M17.1875 19.5625C17.1875 18.4254 16.2621 17.5 15.125 17.5C13.9879 17.5 13.0625 18.4254 13.0625 19.5625C13.0625 20.6996 13.9879 21.625 15.125 21.625C16.2621 21.625 17.1875 20.6996 17.1875 19.5625ZM14.4375 19.5625C14.4375 19.1837 14.7462 18.875 15.125 18.875C15.5038 18.875 15.8125 19.1837 15.8125 19.5625C15.8125 19.9413 15.5038 20.25 15.125 20.25C14.7462 20.25 14.4375 19.9413 14.4375 19.5625Z"-->
                        <!--                            fill="#A3A3A3"-->
                        <!--                          />-->
                        <!--                          <path-->
                        <!--                            d="M2.81875 3.0625C2.904 3.87444 3.85275 12.8862 3.99919 14.2784C4.10987 15.3309 4.99194 16.125 6.05069 16.125H16.764C17.7299 16.125 18.5783 15.4389 18.7811 14.4943L20.4325 6.78806C20.5198 6.37969 20.4194 5.95963 20.1568 5.63581C19.8942 5.31131 19.5044 5.125 19.0871 5.125H4.41856L4.12156 2.3035C4.08444 1.95288 3.7895 1.6875 3.4375 1.6875H1.375C0.9955 1.6875 0.6875 1.9955 0.6875 2.375C0.6875 2.7545 0.9955 3.0625 1.375 3.0625H2.81875ZM19.0871 6.5L17.4364 14.2062C17.3683 14.5211 17.0857 14.75 16.7633 14.75H6.05069C5.69731 14.75 5.40375 14.4853 5.36663 14.1347L4.56294 6.5H19.0871Z"-->
                        <!--                            fill="#A3A3A3"-->
                        <!--                          />-->
                        <!--                        </svg>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{'buy-status': true, 'red': notification}">
      <p>Купите меню, чтобы посмотреть рецепт</p>
      <img
          src="../assets/Group302.svg"
          alt="avatar"
          @click="notification = undefined"
      />
    </div>
  </div>
</template>

<script>
import { readFailure } from "../utils/legacy-safety";
import { replaceIfChanged } from "../utils/readNavigation";
import Subscribe from '../components/TheSubscribe';
import KCalendar from "../components/TheCalendar";
import KSpinner from "../components/TheSpinner.vue";
import AdaptivePropper from '../components/TheAdaptivePropper';
import dateFormat from "../utils/dateformat";
import {getSpecialMenu, getSpecialMenuTags, setDateAndMealType} from "../api/SpecialApi";
import {mapGetters} from "vuex";
import Switcher from '../components/TheSwitcher.vue';
import {sortBy} from '../utils/helper';
import {setCookingFor} from '../api/RecipeApi';
import RecipePopup from '../components/TheRecipePopup.vue';
import VeganIcon from "@/components/icons/VeganIcon";
import EggIcon from "@/components/icons/EggIcon";
import BaseInput from "@/components/elements/BaseInput";
import { businessDate, isShoppingAssignmentActive, shoppingAssignmentForRecipe } from '../utils/shopping-state';

export default {
  name: 'ReceipesSpecial',
  components: {
    BaseInput,
    EggIcon,
    VeganIcon,
    KCalendar,
    KSpinner,
    Subscribe,
    AdaptivePropper,
    Switcher,
    RecipePopup,
  },
  created() {
    if (this.$route.query.search) {
      this.searchRecipe = this.$route.query.search;
    }
    // if (this.$route.params.id && !this.currentSpecialId) {
    //   this.currentSpecialId = this.$route.params.id;
    // } else if (this.getAvaiableUserSets.length > 0 && !this.currentSpecialId) {
    //   this.currentSpecialId = this.getAvaiableUserSets[0].id;
    // }
    // if (this.$route.query.tab) {
    //   this.setNextTab = this.$route.query.tab;
    // }
  },
  data: () => ({
    shoppingToday: businessDate(),
    currentSpecialId: null,
    activeRecipePopup: undefined,
    notification: undefined,
    swiperOption: {
      pagination: {
        el: '.swiper-pagination'
      }
    },
    disableSwiper: false,
    manual: false,

    currentSets: {},
    setNextTab: '',

    searchRecipe: '',
  }),
  mounted() {
    this._shoppingClock = setInterval(() => { this.shoppingToday = businessDate(); }, 60000);
  },
  activated() {
    this.shoppingToday = businessDate();
    if (this.displayMenuId) this.loadSpecial(this.displayMenuId);
  },
  watch: {
    accessSignature() {
      this._readEpoch = (this._readEpoch || 0) + 1;
      this.currentSets = {};
      if (this.currentSpecialId) this.loadSpecial(this.currentSpecialId);
    },
    '$route.query.tab'(value) {
      const entry = this.currentSetsObject;
      if (!entry.sets) return;
      entry.currentSet = value && entry.sets.some(set => set.title === value) ? value : '';
    },
    getAvaiableUserSets(value) {
      this.updateCurrentSpecialId();
      const index = value.findIndex(el => el.id === this.currentSpecialId);
      if (index >= 0 && this.$refs.mySwiper) {
        this.$refs.mySwiper.swiper.slideTo(index, 0, false);
      }
    },
    currentSpecialId(value) {
      if (!value) return;
      replaceIfChanged(this.$router, {
        name: this.$route.name,
        params: {id: value},
        query: {...this.$route.query}
      });
      this.loadSpecial(value);
    },
    '$route.name': {
      immediate: true,
      handler() {
        this.updateCurrentSpecialId();
      },
    },
    '$route.params.id': {
      immediate: true,
      handler() {
        this.updateCurrentSpecialId();
      },
    },
  },
  computed: {
    isSomebodyInMenu() {
      return this.getUserSets.find(el => el.recipe_set_id === this.menu.id)?.profile_recipe_sets?.length > 0;
    },
    displayMenuId() { return this.$route.params.id || this.currentSpecialId; },
    isPreview() { return this.menu.access === 'preview'; },
    accessSignature() { return JSON.stringify([this.getUser && this.getUser.id, this.getUserSets.map(s => [s.recipe_set_id, s.is_paid])]); },
    currentSetsObject() {
      return this.currentSets[this.$route.params.id] || {}
    },
    sets() {
      return this.currentSetsObject.sets || []
    },
    menu() {
      return this.currentSetsObject.menu || {}
    },
    currentSet() {
      return this.currentSetsObject.currentSet || ''
    },
    isLoading() {
      return this.currentSetsObject.loading;
    },
    getSets() {
      let sortingArray = [];
      switch (this.menu.id) {
        case '0d95ba19-64c2-4210-93c6-fa6c19e73ac1': // Integra PNS
          sortingArray = ['Завтрак', 'Обед', 'Ужин', 'Десерты', 'Соусы', 'Хлеб', 'Хлебцы', 'Хлеб и хлебцы']
          break;
        case '1f9e97c4-5d42-4307-ac1c-daa360a047f0': // Хлеб и хлебцы
          sortingArray = ['Хлеб', 'Хлебцы'];
          break;
        case 'c8018c3f-f447-4a56-bc9a-6ca0f5b1ab78': // Меню десертов
          sortingArray = ['Торты', 'Десерты', 'Тесто и коржи', 'Кремы и топпинги'];
          break;
        case '997b2e8f-13ba-4622-8f4f-b6f3e060083b': // Праздничное
          sortingArray = ['Закуски', 'Салаты', 'Горячее', 'Гарниры', 'Соусы', 'Десерты']
          break;
        case 'e8bc1576-fdf5-494d-a90f-c31a43b8a21f': // Меню всей семьи
          sortingArray = ['Завтрак', 'Обед', 'Ужин', 'Перекус', 'Соусы', 'Хлеб', 'Хлебцы', 'Хлеб и хлебцы']
          break;
        case 'b517544a-bcfe-4652-b06f-a4576afb8394': // Пробное меню всей семьи
          sortingArray = ['Завтрак', 'Обед', 'Ужин', 'Перекус', 'Блины', 'Соусы', 'Хлеб', 'Хлебцы', 'Хлеб и хлебцы']
          break;
        case 'a56a6ec7-11fe-4537-8e22-6b74d27b0580': // Вегетарианское меню
          sortingArray = ['Завтраки', 'Завтраки с яйцами', 'Основное блюдо', 'Супы', 'Салаты', 'Десерты', 'Хлеб и хлебцы', 'Соусы']
          break;
        case '0d657f95-f393-42b3-8e6d-eea2c02322a5': // Боулы
          sortingArray = ['Боулы', 'Овощи', 'Белки', 'Углеводы', 'Добавки', 'Соусы' ]
          break;
        default:
          sortingArray = ['Завтрак', 'Обед', 'Ужин'];
          break;

      }
      return sortBy(this.sets, 'title', sortingArray)
    },
    getUserFamilySubscribe() {
      return this.getUserFamily.map(el => {
        const current = this.getUserSets.find(el => el.recipe_set_id === this.menu.id)?.profile_recipe_sets?.find(u => {
          return u.profile_id === el.id;
        })
        return {
          ...el,
          subscribe: current,
        }
      }).filter(el => el.subscribe)
    },
    isBoughtedAndFamily() {
      return this.getUserSets.find(el => el.recipe_set_id === this.menu.id)?.profile_recipe_sets?.length > 0;
    },
    getDishTypeSwitch() {
      return [
        {tab: 'breakfast', title: 'Завтрак'},
        {tab: 'lunch', title: 'Обед'},
        {tab: 'brunch', title: 'Перекус'},
        {tab: 'dinner', title: 'Ужин'},
      ]
    },
    getCurrentSetRecipes() {
      if (!this.currentSet) {
        const res = this.sets.map(set => set.recipes.map(el => {
          if (!el.meal_type) this.$set(el, 'meal_type', '')
          return el;
        })).flat();
        if (this.searchRecipe) {
          return res.filter(el => el.title.toLowerCase().includes(this.searchRecipe.toLowerCase()));
        }
        return res;
      }
      const current = this.sets.find(el => el.title === this.currentSet);
      if (!current) {
        return [];
      }
      const res = current.recipes.map(el => {
        if (!el.meal_type) this.$set(el, 'meal_type', '')
        return el;
      });
      if (this.searchRecipe) {
        return res.filter(el => el.title.toLowerCase().includes(this.searchRecipe.toLowerCase()));
      }
      return res;
    },
    checkSubscribeIsBought() {
      if (this.isPreview) return false;
      return (
          this.getUserSubscribes.some(el => el.menu_id === this.menu.id && el.is_paid === 't') ||
          this.getUserSets.some(el => el.recipe_set_id === this.menu.id && el.is_paid === 't')
      );
    },
    getAvaiableUserSets() {
      const sets = this._getAvailableUserSets;
      if (!sets || !sets.length || !this.$route.meta.recipeSetType) {
        return sets;
      }
      return sets.filter(el => (this.getRecipeSets.find(set => set.id === el.id)?.recipeSetTypes || []).includes(this.$route.meta.recipeSetType));
    },
    ...mapGetters(["getUser", "getUserFamily", 'getUserSubscribes', 'getUserSets', 'getRecipeSets']),
    ...mapGetters({
      _getAvailableUserSets: 'getAvaiableUserSets',
    })
  },
  beforeDestroy() {
    clearInterval(this._shoppingClock);
    this._readEpoch = (this._readEpoch || 0) + 1;
  },
  methods: {
    selectCategory(title) {
      this.currentSetsObject.currentSet = title || '';
      replaceIfChanged(this.$router, { name: this.$route.name, params: { id: this.currentSpecialId }, query: { ...this.$route.query, set: undefined, tab: title || '' } });
    },
    openRecipe(recipe) {
      if (!this.checkSubscribeIsBought) { this.showNotify(); return; }
      const meal = this.getSetMeal(recipe);
      this.$root.$emit('SHOW_RECIPE', { recipe_id: recipe.id, set_meal_id: meal.id, user_recipe_set_id: meal.user_recipe_set_id, date: meal.date ? this.formatDate(meal.date) : this.shoppingToday, type: 'special', menu: this.menu.id });
    },
    updateCurrentSpecialId() {
      // The same component serves both categories. Keep a valid ID even while
      // a category route has no ID, and follow Back to a different recipe set.
      const available = this.getAvaiableUserSets;
      if (available.length > 0) {
        const selected = available.find(el => el.id === this.$route.params.id)
          || available.find(el => el.id === this.currentSpecialId)
          || available[0];
        this.currentSpecialId = selected.id;
        replaceIfChanged(this.$router, {
          name: this.$route.name,
          params: {id: selected.id},
          query: {...this.$route.query}
        });
      }
      if (this.$route.query.tab && this.setNextTab !== this.$route.query.tab) {
        this.setNextTab = this.$route.query.tab;
      }
    },
    showEmptySet() {
      this.$root.$emit('notify', {
        type: 'red',
        text: 'Чтобы управлять списком покупок, добавьте в меню хотя бы один профиль'
      })
    },
    onSlideInit() {
      console.log('Init', this.getAvaiableUserSets.map(el => el.id).indexOf(this.$route.params.id), this.getAvaiableUserSets.map(el => el.id), this.$route.params.id)
      if (!this.$route.params.id) return;
      this.manual = true;
      this.$refs.mySwiper.swiper.slideTo(this.getAvaiableUserSets.map(el => el.id).indexOf(this.$route.params.id))
      this.manual = false;
    },

    onSlideChange() {
      console.log('SLIDE CHANGE!', this.manual)
      if (this.manual) return;

      const index = this.$refs.mySwiper.swiper.snapIndex - this.$refs.mySwiper.swiper.previousIndex;
      const direction = index > 0 ? 'right' : 'left';

      this.handleSwipe(direction);
    },

    checkDateExist(recipe) {
      return (recipe.set_meals || []).some(el => isShoppingAssignmentActive(el, this.shoppingToday));
    },

    checkCurrentSubscribeIsBought(set) {
      return this.getUserSets.some(el => el.recipe_set_id === set.id && el.is_paid === 't')
    },

    async onInit() {
      await this.$nextTick();
      this.$refs.slick.goTo(this.getAvaiableUserSets.findIndex(el => el.id === this.currentSpecialId))
    },

    handleSwipe(direction) {
      if (direction === 'left') {
        this.setPrevSubscribe();
      } else {
        this.setNextSubscribe();
      }
    },

    formatDate(date) {
      return dateFormat(date, 'yyyy-mm-dd')
    },

    setNextSubscribe() {
      if (this.getAvaiableUserSets.length <= 1) return;
      const currentIndex = this.getAvaiableUserSets.findIndex(el => el.id === this.currentSpecialId);
      if (this.getAvaiableUserSets[currentIndex + 1]) {
        this.currentSpecialId = this.getAvaiableUserSets[currentIndex + 1].id;
      } else {
        this.currentSpecialId = this.getAvaiableUserSets[0].id;
      }
    },

    setPrevSubscribe() {
      if (this.getAvaiableUserSets.length <= 1) return;
      const currentIndex = this.getAvaiableUserSets.findIndex(el => el.id === this.currentSpecialId);
      if (this.getAvaiableUserSets[currentIndex - 1]) {
        this.currentSpecialId = this.getAvaiableUserSets[currentIndex - 1].id;
      } else {
        this.currentSpecialId = this.getAvaiableUserSets[this.getAvaiableUserSets.length - 1].id;
      }
    },

    async loadSpecial(id) {
      if (!id || this.currentSets[id]?.loading) return;
      const epoch = this._readEpoch || 0;
      const entry = { ...(this.currentSets[id] || {}), loading: true, error: false, tagsError: false };
      this.$set(this.currentSets, id, entry);
      try {
        const [response, tagResponse] = await Promise.all([
          getSpecialMenu(id),
          getSpecialMenuTags(id).catch(() => null),
        ]);
        if (epoch !== (this._readEpoch || 0)) return;
        if (!response.data.success) throw { response };
        const { recipes, ...menu } = response.data.data.recipe_set;
        const requestedTab = this.$route.params.id === id ? (this.$route.query.set === 'all' ? '' : this.$route.query.tab) : entry.currentSet;
        const currentSet = requestedTab !== undefined ? requestedTab : (recipes[0]?.title || '');
        this.$set(this.currentSets, id, {
          sets: recipes, menu, loading: false, error: false,
          currentSet: recipes.some(set => set.title === currentSet) ? currentSet : '',
          tags: tagResponse?.data?.success ? tagResponse.data.data : [],
          tagsError: !tagResponse?.data?.success,
        });
      } catch (err) {
        if (epoch === (this._readEpoch || 0)) this.$set(entry, 'error', readFailure(err, 'Не удалось загрузить рецепты. Повторите запрос.'));
      } finally {
        if (epoch === (this._readEpoch || 0)) entry.loading = false;
      }
    },
    async makeDateRecipe(recipe) {
      const {data} = await setDateAndMealType({
        date: dateFormat(recipe.date, 'yyyy-mm-dd'),
        recipe_id: recipe.id,
        meal_type: recipe.meal_type,
        recipe_set_id: this.menu.id,
        shopping_action: 'include',
      })

      this.addOrChangeSetMeal(recipe, data);
    },

    addOrChangeSetMeal(recipe, {data}) {
      const set_meal = data.set_meal;
      let current = recipe.set_meals.find(el => el.id === set_meal.id);

      if (current) {
        recipe.set_meals = recipe.set_meals.filter(el => el.id !== set_meal.id);
      }
      recipe.set_meals.push(set_meal);

      this.$forceUpdate();
    },

    getSetMeal(recipe) {
      return shoppingAssignmentForRecipe(recipe.set_meals, this.shoppingToday);
    },

    setDateToRecipe(recipe, date) {
      this.$set(recipe, 'meal_type', null);

      this.$set(recipe, "date", new Date(date));
      const existSetMealWithDate = recipe.set_meals.find(el => dateFormat(el.date, 'yyyy-mm-dd') === dateFormat(date, 'yyyy-mm-dd'))

      if (existSetMealWithDate) {
        recipe.meal_type = existSetMealWithDate.meal_type || ''
        this.$forceUpdate();
      }
    },

    getCurrentFormattedDate(date) {
      const cDate = new Date(date);
      return dateFormat(cDate, "dd mmm");
    },

    async cookingFor(person, active, guests_count = false) {
      const copyPerson = {...person.cooking_for};
      if (guests_count) {
        copyPerson.profile_id = '';
        copyPerson.guests_count = guests_count;
      }

      //TO DO: change person.cooking_for for new data

      // delete person.cooking_for.set_meal_id; // todo
      // const guestObject = this.recipe.cooking_for.find(el => !el.profile_id);

      await setCookingFor({
        ...person.cooking_for,
        cooking_for: active ? 't' : 'f',
        meal_id: this.meal_id,
        set_meal_id: this.set_meal_id,
      })
    },

    showRecipePopup(id) {
      console.log(id)
      this.activeRecipePopup = id;
    },

    backToMenu() {
      this.activeRecipePopup = undefined;
    },

    showNotify() {
      this.notification = true;
    },

    getFillColorByMeal(recipe) {
      if (this.checkDateExist(recipe)) {
        return '#A3A3A3';
      }
      return '#9DC43B';
    },

    getTagOther(recipeId) {
      const id = this.$route.params.id;
      if (!id) {
        return null;
      }
      if (!this.currentSets[id].tags?.length) {
        return null;
      }
      return this.currentSets[id]
          .tags
          .find(tag =>
              tag.recipe_id === recipeId &&
              ['Веган', 'Веган молочка', 'С яйцами'].includes(tag.title)
          );
    },

    recipeHasTag(recipeId, title) {
      const tag = this.getTagOther(recipeId);
      if (!tag) {
        return false;
      }
      return tag.title === title;
    }
  }
};
</script>

<style lang="scss">
.k-menu__dish-card[role="button"]:focus-visible { outline: 2px solid #f68c1e; outline-offset: 3px; }
.k-card-swiper-overhead {
  padding-bottom: 50px;
}

.k-family__members-submit {
  display: flex;
  padding: 20px;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &__container {
    display: flex;
    align-items: center;
  }
}

.k-family__member-avatar-submit {
  border-radius: 4px;
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.k-family__member-no-avatar-submit {
  background: rgba(246, 140, 30, 0.15);
  color: #F68C1E;
  border-radius: 4px;
  text-align: center;
  line-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  width: 40px;
  height: 40px;
  font-size: 24px;
  margin-right: 10px;
}

.k-sprecial-filter {
  .k-filter__switcher-item {
    width: 100%
  }

  width: 100%;
}

.k-subscribes__no-buy-family-title {
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  letter-spacing: -0.41px;
  color: #77767e;
  opacity: 0.6;
  text-align: center;
  margin: 0;

  &--bold {
    font-weight: bold;
    font-size: 22px;
  }
}

.k-subscribes__buy-empty-family-wrapper,
.k-subscribes__no-buy-family-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 0 40px;
}

.k-subscribes__buy-empty-family-wrapper {
  flex-direction: column;
}

.k-menu__plus-button {
  line-height: 1;
}

.k-menu__warning-text {
  display: flex;
  font-size: 10px;
  color: #D51E3A;
  align-items: center;
}

.buy-status {
  position: fixed;
  bottom: -80px;
  right: 20px;
  border-radius: 4px;
  transition: 0.2s linear;
  padding: 16px;
  width: auto;
  min-height: 80px;
  min-width: 300px;
  max-width: 300px;
  display: flex;
  justify-content: space-between;

  &.green {
    background: #9DC43B;
    bottom: 20px;
    z-index: 1;
  }

  &.red {
    background: #C23440;
    bottom: 20px;
    z-index: 1;
  }

  // &.buy-notification {
  //   background-color: black; bottom: 20px; z-index: 1; }
  p {
    align-self: center;
    color: white;
    margin: 0 10px;
  }

  img {
    align-self: flex-start;
    margin-left: 10px;
  }
}

.disabled {
  pointer-events: none;
}

.search-input {
  width: 50%;
  margin-top: 20px;
}

@media (max-width: 767.98px) {
  .search-input {
    width: 100%;
  }
}

.recipe-left-tag-icon {
  z-index: 0;
  position: absolute;
}
</style>
